// src/App.js
import React, { useState, useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Snackbar } from '@mui/material';
import MuiAlert from '@mui/material/Alert';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useDispatch, useSelector } from 'react-redux';
import { showAppAlert } from './store/reducers/appreducer';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './store';
import RouterConfig from './routes/RouterConfig';
import Intercom from '@intercom/messenger-js-sdk';
import ScrollToTop from './components/ScrollTopComponent';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function App() {
  const dispatch = useDispatch();
  const { appAlert } = useSelector((state) => state.appreducer);
  const [alert, setAlert] = useState(appAlert);

  useEffect(() => {
    document.body.style.backgroundColor = '#FFFFFF';
  }, []);

  useEffect(() => {
    Intercom('boot', {
      app_id: 'r4y3y6fs',
    });
  }, []);

  const handleAlertClose = () => {
    const updatedAlert = {
      ...appAlert,
      show: false,
    };
    setAlert(updatedAlert);
    dispatch(showAppAlert(updatedAlert));
  };

  const theme = createTheme({
    typography: {
      fontFamily: [
        'Raleway',
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(','),
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter>
        <ScrollToTop /> 
          <div>
            <RouterConfig />
            <Snackbar
              open={appAlert.show}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
              autoHideDuration={6000}
              onClose={handleAlertClose}
            >
              <Alert
                onClose={handleAlertClose}
                severity={appAlert.alertType || 'info'}
                sx={{ width: '100%' }}
              >
                {appAlert.alertMessage}
              </Alert>
            </Snackbar>
          </div>
        </BrowserRouter>
      </PersistGate>
    </ThemeProvider>
  );
}

export default App;